import { render, staticRenderFns } from "./download.vue?vue&type=template&id=71350048"
import script from "./download.vue?vue&type=script&lang=js"
export * from "./download.vue?vue&type=script&lang=js"
import style0 from "./download.vue?vue&type=style&index=0&id=71350048&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports